<template>
  <div v-click-outside="hideApproveRemove" class="cart-item-remove">
    <button
      class="cart-item-remove__button"
      v-on="{ click: isInWishList ? removeFromList : toggleApproveRemove }"
      :title="$t('remove_from_the_list')"
    >
      <svg width="18"
           height="18"
           viewBox="0 0 18 18"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.75 16.5H5.25C4.42157 16.5 3.75 15.8284 3.75 15V5.25H2.25V3.75H5.25V3C5.25 2.17157 5.92157 1.5 6.75 1.5H11.25C12.0784 1.5 12.75 2.17157 12.75 3V3.75H15.75V5.25H14.25V15C14.25 15.8284 13.5784 16.5 12.75 16.5ZM5.25 5.25V15H12.75V5.25H5.25ZM6.75 3V3.75H11.25V3H6.75ZM11.25 13.5H9.75V6.75H11.25V13.5ZM8.25 13.5H6.75V6.75H8.25V13.5Z"
          fill="#909090"
        />
      </svg>
    </button>
    <div
      v-if="isShowApprovePopup"
      class="cart-item-remove__approve-remove approve-remove"
    >
      <button
        @click.prevent="addToWishList"
        class="approve-remove__btn approve-remove__btn--wish-list"
      >
        {{ $t('cart_to_wish_list') }}
      </button>
      <button
        @click="removeFromList"
        class="approve-remove__btn approve-remove__btn--remove"
      >
        {{ $t('remove_from_the_list') }}
      </button>
      <button
        @click="hideApproveRemove"
        class="approve-remove__btn approve-remove__btn--cancel"
      >
        {{ $t('cart_cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: 'WaitListCardMenu',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    productData: {
      type: Object,
      required: true
    },
    isInWishList: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isShowApprovePopup: false,
      isLoading: false
    }
  },
  methods: {
    toggleApproveRemove () {
      this.isShowApprovePopup = true
    },
    hideApproveRemove () {
      this.isShowApprovePopup = false
    },
    addToWishList () {
      this.$emit('clickWishlist')
    },
    removeFromList () {
      this.$emit('clickRemove')
    }
  }
}
</script>

<style scoped lang="sass">

.cart-item-remove
  position: relative
  flex-shrink: 0

.cart-item-remove__button
  width: 20px
  height: 20px
  padding: 0
  border: 0
  background: none
  opacity: .5

  &:hover
    opacity: 1

.approve-remove
  position: absolute
  right: calc(100% + 20px)
  top: 50%
  transform: translateY(-50%)
  background-color: #ffffff
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15)
  border-radius: 3px
  padding: 5px 10px
  display: flex
  flex-flow: row wrap
  width: 100vw
  max-width: 210px
  z-index: 2

.approve-remove__btn
  width: calc(50% - 15px)
  background-color: transparent
  border: 0
  font-weight: 400
  font-size: 12px
  line-height: 14px
  text-align: center
  padding: 9px 8px
  text-decoration: underline dotted

  &:hover, &:focus
    text-decoration: none

.approve-remove__btn--wish-list, .approve-remove__btn--remove
  position: relative
  padding-top: 42px

  &:before
    content: ''
    width: 26px
    height: 23px
    position: absolute
    top: 9px
    left: 50%
    transform: translateX(-50%)
    background-size: contain
    background-repeat: no-repeat
    background-position: 50%

.approve-remove__btn--wish-list
  margin-right: 15px

  &:before
    background-image: url(/img/svgo/cart/wish-list.svg)

  &:after
    content: ''
    position: absolute
    width: 1px
    height: 60px
    background: #E7E7E7
    top: 10px
    right: -15px

.approve-remove__btn--remove
  margin-left: 15px

  &:before
    background-image: url(/img/svgo/cart/remove.svg)

.approve-remove__btn--cancel
  width: 100%

</style>
